import React from 'react';
import { Modal, Backdrop } from '@material-ui/core';
import { Grid, GridItem } from '@patternfly/react-core';
import PropTypes from 'prop-types';

import useTranslateText from './use_translate_text';
import { PrimaryButtonCloseIcon, PrimaryButton } from './primary_button';
import '../scss/popup_modal.scss';


const PopupModal = (props) => {
  const { canShowPopup, children, onClose, title, onSubmit, onCancel, className, onOK, onOk, onRefresh, isCancelRemove } = props,
        { translateText } = useTranslateText(),
        classNames = `popup-modal ${className}`;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      onClose={onClose}
      closeAfterTransition
      className="popup-modal__container"
      open={canShowPopup}
    >
      <Grid className={classNames}>
        {title &&
          <GridItem className="border-bottom-2">
            <p className="f20-title m-0">
              {translateText(title)}
              <PrimaryButtonCloseIcon
                icon="times-circle"
                onClick={onClose}
              />
            </p>
          </GridItem>
        }
        <GridItem className="border-bottom-2">
          {children}
        </GridItem>
        <GridItem className="text-right">
          {onRefresh &&
            <PrimaryButton
              className="mr-1"
              icon="redo"
              label="Refresh"
              onClick={onRefresh}
              size="1x"
            />
          }
          {onSubmit &&
            <PrimaryButton
              className="mr-1"
              icon="check-circle"
              label="Submit"
              onClick={onSubmit}
              size="1x"
            />
          }
          {onOK &&
            <PrimaryButton
              className="mr-1"
              icon="check-circle"
              label="OK"
              onClick={onOK}
              size="1x"
            />
          }
          {onOk &&
            <PrimaryButton
              className="mr-3"
              icon="check-circle"
              label="OK"
              onClick={onOk}
              size="2x"
            />
          }
          {onCancel ?
            <PrimaryButton
              className="mr-1"
              icon="times-circle"
              label="Cancel"
              onClick={onCancel}
              size="1x"
            /> : !isCancelRemove && <PrimaryButton
              className="mr-1"
              icon="times-circle"
              label="Cancel"
              onClick={onClose}
              size="2x"
            />}
        </GridItem>
      </Grid>
    </Modal>
  );
};

export default PopupModal;

PopupModal.propTypes = {
  canShowPopup: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  onCancle: PropTypes.func,
  onOk: PropTypes.func,
};

/* ---------------Example----------------
  const canShowPopup = true,
        title = 'Popup Example',
        onClose = () => {
          setState('canShowPopup', false);
        },
        onSubmit = () => {
          do submit code here
        },
        className = 'component-name__popup';

  <PopupModal
    canShowPopup={canShowPopup}
    className={className}
    onClose={onClose}
    onSubmit={onSubmit}
    title={title}
  >
    <div> Try this example </dev>
  </PopupModal>
*/